import { render, staticRenderFns } from "./add-person.vue?vue&type=template&id=73840574&"
import script from "./add-person.vue?vue&type=script&lang=js&"
export * from "./add-person.vue?vue&type=script&lang=js&"
import style0 from "./add-person.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports